import { useQuery } from "@tanstack/react-query"

import {
  getPlannedEvents,
  getReferralInfo,
  getSBCredentials,
  loadCareTeam,
} from "./api"
import { QUERY_KEYS } from "../../constants"
import { useReferralLandingPageStore } from "../../pages/referralLanding/ReferralLandingPage"
import { PlannedEventIdentifier } from "../../types"
import { useUserQuery } from "../queries"

export const useSBCredentialsQuery = (enabled: boolean = false) => {
  const { user } = useUserQuery()
  return useQuery({
    queryKey: [QUERY_KEYS.SB_CREDENTIALS],
    queryFn: () => getSBCredentials(user?.id!),
    enabled: !!user?.id && enabled,
  })
}

export const useCareTeamQuery = () => {
  const { user } = useUserQuery()
  return useQuery({
    queryKey: [QUERY_KEYS.CARE_TEAM],
    queryFn: () => loadCareTeam(user?.id!),
    enabled: !!user,
  })
}

export const useReferralInfoQuery = () => {
  const { uuid } = useReferralLandingPageStore()

  return useQuery({
    queryKey: [QUERY_KEYS.REFERRAL_INFO],
    queryFn: () => getReferralInfo(uuid!),
    enabled: !!uuid,
    retry: false,
  })
}

export const usePlannedEventsQuery = () => {
  const { user } = useUserQuery()
  const identifier = PlannedEventIdentifier.DOTER_MERGE

  return useQuery({
    queryKey: [QUERY_KEYS.PLANNED_EVENTS, identifier],
    queryFn: () => getPlannedEvents(identifier),
    enabled: !!user,
  })
}
